import React from 'react';

const NotFoundPage = () => {
    return <h2>404 - Página no encontrada</h2>;
};

export default NotFoundPage;